import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from './components/AuthCallback';
import Homepage from './pages/Homepage';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import SubmitStory from './pages/SubmitStory';
import Resources from './pages/Resources';
import Community from './pages/Community';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

function AppRouter() {
  const location = useLocation();
  
  // Handle OAuth callback before any other routing
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navigation />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/articles/:slug" element={<ArticleDetail />} />
        <Route path="/community" element={<Community />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/submit-story" element={
          <ProtectedRoute>
            <SubmitStory />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        <Route path="*" element={
          <div className="min-h-screen flex items-center justify-center bg-ivory">
            <div className="text-center space-y-4">
              <p className="font-script text-4xl text-gold">Oh No!</p>
              <h1 className="text-4xl font-serif font-bold text-charcoal">Page Not Found</h1>
              <p className="text-charcoal/70">The page you're looking for doesn't exist.</p>
              <a href="/" className="btn-gold inline-block px-6 py-3 rounded-full font-medium">
                Back to Sisterhood
              </a>
            </div>
          </div>
        } />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <AppRouter />
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
